import React, { useState, useEffect, useRef, useMemo, useCallback } from "react"
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { useHistory, useLocation } from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-rangeslider/lib/index.css'
import 'antd/dist/antd.css'
import { HeliosWrap, createApiClient, VersionChecker } from '@oneblinktech-org/helios-base'
import SearchActions from './components/searchActions';
import { useDispatch, useSelector } from 'react-redux'
import PlanningBoard from "./pages/planningBoard"
import Profile from './pages/user/Profile'
import JobList from './pages/job/JobList'
import Job from './pages/job/Job'
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import {
  getJobByOrg
} from './store/job/actions';
import { menus as initialMenus } from './fakeData/sideBar';
import { konamiKeyEvent, removeKonamiKeyEvent } from "./helpers/globals"
import { getCookie } from "./helpers/globals"
import Connections from "./pages/Settings/Connections"
import Logo from "./components/common/logo"
import CustomerList from "./pages/Customers/CustomerList"
import JobModal from "./components/JobModal"
import { initializePusher, unbindPusher } from "./pusherManager"
import Settings from "./pages/Settings/Settings"
import AutoLogout from "./pages/AutoLogout"

const apiUrl = process.env.REACT_APP_API_URL;
const { get, post } = createApiClient({ apiUrl });

function App(props) {
  konamiKeyEvent()
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()
  const [menus, setMenus] = useState(initialMenus);
  const initialRender = useRef(true);
  const countData = useSelector((state) => state.NoteReducer.countData);
  const user = useSelector((state) => state.UserReducer.user);
  const isNewJob = useSelector((state) => state.JobReducer.isNewJob )
  const orgId = getCookie('active_organization_id')
  const isUpdateData = useSelector((state) => state.UserReducer?.isUpdateData)
  
  useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.split('?')[1] : '';
    const params = new URLSearchParams(queryString);
    const jobId = params.get('jobId');

    let jobCard = document.querySelector('.job-item');
    if (jobId) {
      setTimeout(() => {
        handleJobCardClick(jobId);
      }, jobCard ? 200 : 3000);
    }
  }, [location, history])

  const handleJobCardClick = (jobId) => {
    if (jobId) {
      let jobCard = document.querySelector('.job-item');
      if (jobCard) {
        jobCard.click();
        dispatch({ type: "GET_CHOOSE_JOB", id: jobId, loading: true })
        dispatch({ type: 'SET_IS_NEW_JOB', payload: false })
      }
    }
  };

  useEffect(() => {
    localStorage.removeItem("pusher-active");
  },[])

  
  useEffect(() => {
    if (Object.keys(user?.data || {}).length > 0) {
      dispatch({ type: "GET_COUNTER_DATA" });
    }
  }, [user?.data])

  useEffect(() => {
    if(initialRender.current) {
      initialRender.current = false;
    } else {
      updateCounter(countData)
    }
  }, [countData])
  
  const updateCounter = useCallback((result) => {
    if (result && result !== undefined) {
      const newMenus = initialMenus.map(menu => {
        if (menu.name === 'planning') {
          return {
            ...menu,
            count: result?.planning_count || 0,
          };
        }
        return menu;
      });

      setMenus(newMenus);
    }
  }, []);

  return (
    <div className="App">
      <VersionChecker />
      <Switch>
        <Route path={["/jobs", "/job/edit/:id", "/profile", "/connections", "/customers", "/settings", "/logout"]}>
          <HeliosWrap
            captchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
            googleClientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            fullWidth={false}
            orgChangeEvent={(orgId) => dispatch(getJobByOrg(orgId))}
            siteLogo={<Logo />}
            siteText="Helios"
            searchComponent={<SearchActions />}
            isWelcome={false}
            leftSidebarItems={menus}
            apiUrl={process.env.REACT_APP_API_URL}
            isNavShow={process.env.REACT_APP_SHOW_NAV_SIDE || true}
            isUpdateData={isUpdateData}
          >
            <Switch>
              <Route path="/jobs" render={() => <JobList />} />
              <Route path="/job/edit/:id" render={(props) => <Job {...props} />} />
              <Route path="/profile" render={() => <Profile />} />
              <Route path="/settings" render={() => <Settings />} />
              <Route path="/connections" render={() => <Connections />} />
              <Route path="/customers" render={() => <CustomerList />} />
              <Route path="/logout" render={() => <AutoLogout />} />
              {/*<Route path="/" component={Dashboard} />*/}
            </Switch>
          </HeliosWrap>
        </Route>
        <Route path={["/planning", "/production", "/"]}>
          <HeliosWrap
            captchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
            googleClientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            fullWidth={true}
            orgChangeEvent={(orgId) => dispatch(getJobByOrg(orgId))}
            leftSidebarItems={menus}
            siteLogo={<Logo />}
            siteText="Helios"
            searchComponent={<SearchActions />}
            isWelcome={false}
            apiUrl={process.env.REACT_APP_API_URL}
            isNavShow={process.env.REACT_APP_SHOW_NAV_SIDE || true}
            isUpdateData={isUpdateData}
          >
            <Switch>
              <Route path="/planning" render={() => <PlanningBoard />} />
              <Route path="/production" render={() => <Home />} />
              <Route path="/dashboard" render={() => <Dashboard />} />
              <Route path="/" render={() => localStorage.getItem('defaultLandingPage') === '/planning' ? <PlanningBoard />
                : localStorage.getItem('defaultLandingPage') === '/dashboard' ? <Dashboard />
                  : <Home />}
              />
            </Switch>
          </HeliosWrap>
        </Route>
      </Switch>

      <JobModal />
    </div>
  );
}

export default App;